import conn from "@/store/utils/connection";
import metaAPI from "@/store/utils/api-route/metaAPI";
import store from "../store";
import heic2any from "heic2any";
import whitelabelApi from "@/store/utils/api-route/whitelabelApi";

export default {
  methods: {
    searchHighlight: (sourceString, searchString) => {
      var highlight = sourceString
        .toLowerCase()
        .indexOf(searchString.toLowerCase());
      if (highlight < 0) {
        return sourceString;
      }
      return (
        sourceString.substring(0, highlight) +
        '<span class="search-highlight">' +
        sourceString.substring(highlight, highlight + searchString.length) +
        "</span>" +
        sourceString.substring(highlight + searchString.length)
      );
    },
    listenCapslock: (event, id) => {
      if (event.getModifierState("CapsLock")) {
        $("#" + id)
          .siblings(".error")
          .children(".capslock")
          .show();
      } else {
        $("#" + id)
          .siblings(".error")
          .children(".capslock")
          .hide();
      }
    },
    backButtonPressed(callback) {
      window.onpopstate = () => {};
      history.pushState(null, null, document.URL);
      window.onpopstate = () => {
        callback();
        history.pushState(null, null, document.URL);
      };
    },
    formatRupiah(angka) {
      // raw from database, type float
      var number_string = angka
          .toString()
          .replace(/[^-.\d]/g, "")
          .toString(),
        split = number_string.split("."),
        sisa = split[0].length % 3,
        rupiah = split[0].substr(0, sisa),
        ribuan = split[0].substr(sisa).match(/\d{3}/gi);

      if (ribuan) {
        var separator = sisa ? "." : "";
        rupiah += separator + ribuan.join(".");
      }

      return (rupiah =
        split[1] !== undefined ? rupiah + "," + split[1] : rupiah);
    },

    // progress transaksi
    kondisiPengerjaan(transaksi) {
      return transaksi.status_selesai !== 2;
    },
    kondisiBelumDiambil(transaksi) {
      return (
        transaksi.status_selesai === 2 &&
        transaksi.status_ambil === 0 &&
        transaksi.isantar === 0
      );
    },
    kondisiSebagianDiambil(transaksi) {
      return (
        transaksi.status_selesai === 2 &&
        transaksi.status_ambil === 1 &&
        transaksi.isantar === 0
      );
    },
    kondisiSudahDiambil(transaksi) {
      return (
        transaksi.status_selesai === 2 &&
        transaksi.status_ambil === 2 //bisa diambil walaupun menggunakan pengantaran
      );
    },
    kondisiBelumDiantar(transaksi) {
      let statusAntar = 0;
      transaksi.status_antar === undefined
        ? (statusAntar = transaksi.pengantaran.status_antar)
        : (statusAntar = transaksi.status_antar);
      return (
        transaksi.status_selesai === 2 &&
        transaksi.isantar === 1 &&
        statusAntar !== 2
      );
    },
    kondisiSudahDiantar(transaksi) {
      let statusAntar = 0;
      transaksi.status_antar === undefined
        ? (statusAntar = transaksi.pengantaran.status_antar)
        : (statusAntar = transaksi.status_antar);
      return (
        transaksi.status_selesai === 2 &&
        transaksi.isantar === 1 &&
        statusAntar === 2
      );
    },

    getUserAgent() {
      var iosDevice = !!navigator.userAgent.match(
        /iPhone|iPod|iPad|Macintosh/i
      );
      var androidDevice = !!navigator.userAgent.match(/Android/i);
      if (iosDevice) {
        return "ios";
      } else if (androidDevice) {
        return "android";
      } else {
        this.userAgent = "";
      }
    },
    getUserTimezone() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    getDateWithTimezone(date, format, tz) {
      return this.$moment(date).tz(tz).format(format);
    },

    setQueryString(query, set, reset) {
      if (query.length > 0) {
        this.$store.commit(set, query);
        this.$router.replace({ query: query });
      } else {
        this.$store.commit(reset);
      }
    },

    formatMilisecond(milisecond) {
      let hours = (
        "0" +
        Math.floor((milisecond % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      ).slice(-2);
      let minutes = (
        "0" + Math.floor((milisecond % (1000 * 60 * 60)) / (1000 * 60))
      ).slice(-2);
      let seconds = ("0" + Math.floor((milisecond % (1000 * 60)) / 1000)).slice(
        -2
      );
      return hours + " : " + minutes + " : " + seconds;
    },

    downloadImage(imageUrl, name) {
      imageUrl = imageUrl.replace(
        /^data:image\/png/,
        "data:application/octet-stream"
      );

      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = "QRIS_" + name + ".png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    jenisPembayaran(jenisBayar) {
      let res = "";
      switch (jenisBayar) {
        case 1:
          res = "Tunai";
          break;
        case 3:
          res = "Debit";
          break;
        case 4:
          res = "Epayment";
          break;
        case 5:
          res = "Deposit";
          break;
        case 6:
          res = "Paylink";
          break;
        case 10:
          res = "QRIS";
          break;
        case 11:
          res = "EDC";
          break;
        default:
          res = "";
          break;
      }
      return res;
    },
    groupingArray(listArray, key) {
      return listArray.reduce((r, a) => {
        r[a[key]] = [...(r[a[key]] || []), a];
        return r;
      }, {});
    },
    getTimezone() {
      let tz = this.$moment().format("Z");
      let zonaWaktu = "";
      switch (tz) {
        case "+07:00":
          zonaWaktu = "WIB";
          break;
        case "+08:00":
          zonaWaktu = "WITA";
          break;
        case "+09:00":
          zonaWaktu = "WIT";
          break;
        default:
          zonaWaktu = tz;
          break;
      }
      return zonaWaktu;
    },
    saldoValid() {
      const saldo =
        this.$store.state.filterGlobalModule.filterItem.filterSaldoEpayment;
      if (saldo.minimal > saldo.maksimal) {
        this.$toast.error(
          "Saldo maksimal harus lebih besar dari saldo minimal"
        );
        return false;
      } else {
        return true;
      }
    },
    forceLogout() {
      var myItem = localStorage.getItem("incontext-device");
      localStorage.clear();
      localStorage.setItem("incontext-device", myItem);
      this.$router.replace("/startscreen");
    },
    isWebview() {
      return store.state.metaModule.isWebview;
    },
    iframeSrc() {
      if (this.isWebview()) {
        const flutterConfig = JSON.parse(localStorage.getItem("flutterConfig"));
        const bossUrl =
          flutterConfig.apiBase == "https://owner-api-dev.smartlink.id/"
            ? "https://dev-bos.smartlink.id/"
            : "https://boss.smartlink.id/";
        return bossUrl;
      } else return process.env.VUE_APP_BOS_URL;
    },
    async getNewUIStatus() {
      const isFetchedBetaOwner = store.state.metaModule.isFetchBetaOwne;
      if (isFetchedBetaOwner || this.isWebview()) {
        return;
      }
      try {
        const res = await conn.get(metaAPI.new_owner_beta);
        if (res.data.status) {
          store.commit("metaModule/setIsFetchBetaOwner", true);
          if (res.data.data.enable > 0) {
            //! Comment this code if you want to run local
            this.switchNewSmartowner();
          }
        }
      } catch (error) {
        console.log("error: ", error);
      }
    },
    async getWhitelabelSetting() {
      const isFetchedBetaOwner = store.state.metaModule.isFetchBetaOwne;
      if (isFetchedBetaOwner || this.isWebview()) {
        return;
      }
      try {
        const res = await conn.get(whitelabelApi.setting);
        if (res.data.status) {
          localStorage.setItem(
            "whitelabelSetting",
            JSON.stringify(res.data.data)
          );
          store.commit("metaModule/setWhitelabelSetting", res.data.data);
        }
      } catch (error) {
        console.log("error: ", error);
      }
    },
    switchNewSmartowner() {
      const token = localStorage.getItem("token");
      const url = `${process.env.VUE_APP_FLUTTER_HOST}initial?token=${token}&user_type=owner`;
      var myItem = localStorage.getItem("incontext-device");
      localStorage.setItem("incontext-device", myItem);
      window.open(url, "_top");
    },
    validateAccess(key) {
      const isWebview = this.$store.state.metaModule.isWebview;
      const acList = this.$store.state.metaModule.aclList;
      if (acList === "owner" || !isWebview) return true;
      return acList.includes(key);
    },
	flutterChannel(type, action, value, isReset) {
        const data = JSON.stringify(
            {
                type: type,
                action: action,
                value: value,
				is_reset: isReset
            });
        return window.flutter_inappwebview.callHandler('fromJS', data);
	},
    flutterNavigate(route, isReset = false) {
      const flutterConfig = JSON.parse(localStorage.getItem("flutterConfig"));
      console.log("flutterChannel", "route", "/" + route);
      if (flutterConfig.platform === "web") {
        window.open(flutterConfig.webBase + "/" + route, "_top");
      } else {
        let routeType = route == "dashboard" ? "dashboard" : "route";
        if (route.includes("dashboard/notification")) {
          routeType = "dashboard";
        }
		this.flutterChannel(routeType, "/" + route, undefined, isReset);
      }
    },

    flutterDownload(url) {
      const flutterConfig = JSON.parse(localStorage.getItem("flutterConfig"));
      if (flutterConfig.platform === "web") {
        return;
      } else {
        this.flutterChannel("download", url);
      }
    },
    flutterSendWa(phone, text) {
      const flutterConfig = JSON.parse(localStorage.getItem("flutterConfig"));
      if (flutterConfig.platform !== "web") {
        return;
      }
    },
    flutterHandleCommunicate(context, phone) {
      const flutterConfig = JSON.parse(localStorage.getItem("flutterConfig"));
      if (flutterConfig.platform !== "web") {
        this.flutterChannel(context, phone);
        return;
      }
    },
    isMobileDevice() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      }
      return false;
    },
    smartTrackingClickMenu(event_name, payload) {
      this.smartTracking("clmn#" + event_name, payload);
    },
    smartTrackingClickDashboard(event_name, payload) {
      this.smartTracking("cldb#" + event_name, payload);
    },
    smartTrackingClick(event_name, payload) {
      this.smartTracking("cl#" + event_name, payload);
    },
    smartTrackingErrorValidate(event_name, payload) {
      this.smartTracking("errval#" + event_name, payload);
    },
    smartTrackingView(event_name, payload) {
      this.smartTracking("vp#" + event_name, payload);
    },
    smartTracking(event_name, payload) {
      // alert(event_name);
      const id_owner = localStorage.getItem("idowner");
      var required_payload = {
        idowner: id_owner,
        isWebView: this.isWebview(),
        isMobileDevice: this.isMobileDevice(),
        linkUrl: document.URL,
      };

      let parameters = required_payload;
      if (payload !== undefined) {
        if (typeof payload === "object") {
          parameters = { ...required_payload, ...payload };
        } else {
          console.log("payload must be an object");
        }
      }
      console.log("event " + event_name);
      // console.log(parameters);
      gtag("event", event_name, parameters);
    },
    getBetaFeature(key, isForce = false) {
      if (isForce) {
        return true;
      }
      const betaFeatureOwnerAccess =
        this.$store.state.metaModule.betaFeatureOwnerAccess.feature;
      return betaFeatureOwnerAccess.includes(key);
    },
    async heicToJpg(imageUrl) {
      try {
        const blob = await fetch(imageUrl).then((res) => res.blob());
        const conversionResult = await heic2any({
          blob,
          toType: "image/jpeg",
          quality: 1,
        });
        var url = URL.createObjectURL(conversionResult);
        console.log(url);
        return url; // Resolve the promise with the desired value
      } catch (e) {
        console.log("error", e);
        throw e;
      }
    },
		removeSpecialChar(str) {
			return str.replace(/[^\x20-\x7E\n\r\t]/g, '');
		},
  },
};
